/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import accountService from './../../services/account';
import authService from './../../services/auth';
import orderProductService from './../../services/orderProduct';
import ediOrderService from './../../services/ediOrder';
import orderService from './../../services/order';
import shippingService from './../../services/shippingProvider';
import organizationSettingsService from './../../services/organizationSettings';
import { mapGetters, mapMutations } from 'vuex';
import shippingTransformer from './../../transformers/shippingConfirm';
import Forms from './../../utils/forms/forms';
import moment from 'moment';

export default {
  props: {
    warehouseId: {
      Type: Number,
      required: true,
    },
  },

  data() {
    return {
      form: new Forms({
        shippingProviderId: {
          value: '',
          type: 'select',
        },
        shippingDate: {
          value: '',
          type: 'date',
        },
      }),
      loading: false,
      displayError: false,
    };
  },

  computed: {
    ...mapGetters({
      currentOrder: 'currentOrder',
      shippingProviders: 'allShippingProviders',
      currentEdiOrder: 'currentEdiOrder',
      account: 'account',
      settings: 'organizationSettings',
      orderProducts: 'allOrderProducts',
    }),

    unassignedProducts() {
      return this.orderProducts.filter(op => op.quantityConfirmed != op.quantityPacked);
    },
  },

  mounted() {
    this.getResources();
  },

  watch: {
    //
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    setShippingProviders(shippingProviders) {
      let hasModule = false;
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Shipping Provider') {
            // this.form.hideField('warehouseId');
            hasModule = true;
          }
        }
      }
      if (hasModule) {
        this.form.setOptions('shippingProviderId', shippingProviders.map(c => ({ id: c.id, name: `${c.name} ` })));
        if (this.form.options.shippingProviderId.length > 0) this.displayError = false;
      } else {
        this.displayError = false;
        this.form.hideField('shippingProviderId');
      }
    },

    /**
     * Fetch the component's required resources.
     */
    getResources() {
      this.loading = true;
      Promise.all([
        // shippingService.all(),
        shippingService.warehouseShippingProvider(this.warehouseId),
        organizationSettingsService.show(),
      ]).then((data) => {
        this.loading = false;
        if (data[0].length == 0) {
          this.displayError = true;
          this.loading = false;
        } else {
          this.loading = false;
          this.form.shippingProviderId = data[0][0].id;
        }
        this.setShippingProviders(data[0]);
        this.form.assignData({ shippingDate: moment(this.currentEdiOrder.requestedDeliveryDate.split('.').join('-'), 'DD-M-Y').format('Y-MM-DD') });
      });
    },

    store() {
      this.loading = false;
      this.form.loading = true;
      const client = shippingTransformer.send(
        Object.assign({}, this.form.data())
      );
      return ediOrderService.process(this.currentEdiOrder.id, client)
        .then((data) => {
          this.loading = false;
          if (data.xml) {
            this.$msgbox({
              title: 'XML',
              message: data.xml,
              customClass: 'xmlModalCustomClass',
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('static.ediOrders.edit.processSuccess'),
              type: 'success',
            });
          }
          this.closeModal();
        }).catch((errors) => {
          this.loading = false;
          this.form.loading = false;
          let message = this.$t('static.ediOrders.edit.confirmError');
          if (errors.data.shipping_provider_id) {
            message = errors.data.shipping_provider_id[0];
          }
          if (errors.data.shipping_date) {
            message = this.$t('static.ediOrders.edit.invalidDeliveryDate');
          }

          if (errors.data.shipping_provider_id) {
            message = errors.data.shipping_provider_id[0];
          }
          this.form.recordErrors(shippingTransformer.fetch(errors.data));
          this.$message({
            showClose: true,
            message,
            customClass: 'error',
          });
        });
    },
    /*
     * Closes the modal
     */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/ediOrderConfirmShipping/ediOrderConfirmShipping.js